import { courses as CoursesServices } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../error';
import logger from '../../../common/services/logService';
import { coursesTypes } from '../../reducers/types';
import getCourseMaterials from './getCourseMaterials';

export const createFolderStart = () => ({
  type: coursesTypes.CREATE_MATERIAL_START,
});

export const createFolderEnd = () => ({
  type: coursesTypes.CREATE_MATERIAL_END,
});

export default ({ courseId, folder, callback }) =>
  async dispatch => {
    try {
      dispatch(createFolderStart());
      await CoursesServices.createFolder({ courseId, folder });
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(createFolderEnd());
      dispatch(getCourseMaterials(courseId));
    }
  };
